import React, { useState } from 'react';
import styled from 'styled-components';
import logo from '../Assets/Logo.png';
import cot from '../Assets/cot.jpg';
import teamMember1 from '../Assets/teams/Pailanan.png';
import SubJ from '../Assets/teams/Sub1.png';
import teamMember2 from '../Assets/teams/Tumale.png';
import SubT from '../Assets/teams/Sub2.png';
import teamMember3 from '../Assets/teams/Backend.png';
import SubB1 from '../Assets/teams/Analyst.png';
import SubB2 from '../Assets/teams/Analyst2.png';
import SubB3 from '../Assets/teams/6.png';
import SubB4 from '../Assets/teams/7.png';
import teamMember4 from '../Assets/teams/UI.png';
import teamMember5 from '../Assets/teams/cardana.jpg';
import Sub5 from '../Assets/teams/sub5.png';
import teamMember6 from '../Assets/teams/perin.jpg';
import Sub6 from '../Assets/teams/sub6.png';
import teamMember7 from '../Assets/teams/P.png';
import teamMember8 from '../Assets/teams/Tejada.png';
import teamMember9 from '../Assets/teams/gumanoy.jpg';
import Sub9 from '../Assets/teams/sub9.png';
import assistantImage from '../Assets/about1.png';

import a1 from '../Assets/teams/a1.jpg';
import a2 from '../Assets/teams/a2.png';
import a3 from '../Assets/teams/a3.jpg';

const Collaborations = () => {
  return (
    <Container>
      <Title>Collaborations and Partnerships</Title>
      <Text>
        At DISA, we value strong partnerships that help drive innovation and improve the impact of our irrigation systems.
        Our collaborations with stakeholders, government bodies, research institutions, and technology partners enable us to deliver sustainable solutions.
      </Text>

      <Section>
        <Subtitle>Collaboration with Our Partners</Subtitle>
        <Text>
          We are proud to collaborate with DISA to create a dynamic, user-friendly website aimed at improving communication, accessibility, and service delivery.
          By leveraging advanced digital technologies, we are helping DISA reach more people, ensuring seamless interaction with farmers and stakeholders worldwide.
        </Text>
        <LogoWrapper>
          <LogoImage src={logo} alt="DISA Logo" />
          <p>Our digital partnership with DISA continues to empower agricultural development globally.</p>
          <LogoImageC src={cot} alt="DISA Logo" />
        </LogoWrapper>
      </Section>

      <Section>
        <Subtitle>Project Team Behind the Website</Subtitle>
        <Text>
          A talented team of developers, designers, and project managers worked together to bring this website to life.
          Below are the faces of the team who contributed to this collaborative effort, grouped by project phase:
        </Text>
        <TeamSection>
          <Subtitle>Phase 1</Subtitle>
          <TeamWrapper>
            <TeamMember
              name="JEANY BABE G. PAILANAN"
              role="Project Lead"
              defaultImage={teamMember1}
              hoverImage={SubJ}
            />
            <TeamMember
              name="ALDRIN S. TUMALE"
              role="Mobile Developer"
              defaultImage={teamMember2}
              hoverImage={SubT}
            />
            <TeamMember
              name="JASTINE L. GAUDICOS"
              role="UI Designer"
              defaultImage={teamMember4}
              hoverImage={assistantImage}
            />
            <TeamMember
              name="JAYA & PERESOREZ"
              role="Backend Incharge"
              defaultImage={teamMember3}
              hoverImage={teamMember3}
              subImages={[
                { img: SubB1, name: "JADE MADIJANON", role: "Data Analyst" },
                { img: SubB2, name: "AILEEN LAGURA", role: "Data Analyst" },
                { img: SubB3, name: "CLAIRE JANE DELIMAN", role: "Security Analyst" },
                { img: SubB4, name: "ELLA MAE ANCOG", role: "System Analyst" }
              ]}
            />

            <TeamMember
              name="REX VINCENT D. TEJADA"
              role="Mobile Consultant"
              defaultImage={teamMember8}
              hoverImage={assistantImage}
            />
            <TeamMember
              name="JOEL A. PIOLLO"
              role="Project Consultant"
              defaultImage={teamMember7}
              hoverImage={assistantImage}
            />
            <TeamMember
              name="MAX ANGELO D. PERIN"
              role="Backend/ Web Specialist"
              defaultImage={teamMember6}
              hoverImage={Sub6}
            />
            <TeamMember
              name="DARREL A. CARDAÑA"
              role="Project Manager"
              defaultImage={teamMember5}
              hoverImage={assistantImage}
            />

            <TeamMember
              name="CECILIA T. GUMANOY"
              role="Content Specialist"
              defaultImage={teamMember9}
              hoverImage={Sub9}
            />

          </TeamWrapper>
          <Subtitle>Phase 2</Subtitle>
          <TeamWrapper>

            <TeamMember
              name="ZACH ANDREW O. LUMANTAS"
              role="Project Leader"
              defaultImage={a1}
              hoverImage={assistantImage}
            />
            <TeamMember
              name="MARY GRACE L. CADENAS"
              role="Assistant Project Leader / Analyst"
              defaultImage={a2}
              hoverImage={assistantImage}
            />
            <TeamMember
              name="MELVA B. GUMAPAC"
              role="Documentator "
              defaultImage={a3}
              hoverImage={assistantImage}
            />

          </TeamWrapper>
        </TeamSection>
      </Section>
    </Container>
  );
};

const TeamMember = ({ name, role, defaultImage, hoverImage, subImages = [] }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <MemberContainer
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <TeamImage src={isHovered ? hoverImage : defaultImage} alt={name} />
        <TeamName>{name}</TeamName>
        <TeamRole>{role}</TeamRole>
      </MemberContainer>

      {isHovered && subImages.length > 0 && (
        <SubImageModal>
          <ModalContent onMouseLeave={() => setIsHovered(false)}>
            {subImages.map((item, i) => (
              <SubImageItem key={i}>
                <SubImage src={item.img} alt={item.name} />
                <SubText>{item.name}</SubText>
                <SubRole>{item.role}</SubRole>
              </SubImageItem>
            ))}
          </ModalContent>
        </SubImageModal>
      )}
    </>
  );
};



// Styled Components

const Container = styled.div`
  --template-bg: #e7f2ec;
  padding: 0px;
  background-color: var(--template-bg);
  max-width: 1300px;
  margin: 0 auto;
  font-family: 'Arial', sans-serif;
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
`;

const Text = styled.p`
  font-size: 18px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 10px;
`;

const Section = styled.div`
  margin-bottom: 40px;
  background-color: var(--template-bg);
`;

const Subtitle = styled.h3`
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;


const LogoImage = styled.img`
  width: 80px; 
  height: auto;
  margin-right: 20px;
`;

const LogoImageC = styled.img`
  width: 200px; 
  height: auto;
  margin-left: 80px;
`;

const TeamWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap; 
  gap: 10px; 
  height: 230px;
 
`;

const MemberContainer = styled.div`
  text-align: center;
  width: 160px;
  margin-right: 0px;
  padding: 0px;
  border-radius: 16px;
  position: relative;
  transition: transform 0.3s ease;
  background: var(--template-bg);
  box-shadow: 0 4px 32px rgba(0,0,0,0.12), 0 1.5px 6px rgba(0,0,0,0.08);
  border: 1.5px solid #d7e8de;
  overflow: hidden;

  &:hover {
    transform: translateY(-19px);
    z-index: 10;
    background: var(--template-bg);
    box-shadow: 0 8px 40px rgba(0,0,0,0.18), 0 2px 8px rgba(0,0,0,0.12);
  }
`;

const TeamSection = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; 
  -ms-overflow-style: none; 
   padding-top: 20px;

  &::-webkit-scrollbar {
    display: none; 
     height: 6px;
  }
`;

const TeamImage = styled.img`
  width: 140px;
  height: 160px;
  margin-bottom: 5px;
  transition: opacity 0.3s ease, box-shadow 0.3s;
  border-radius: 12px;
  position: relative;
  z-index: 1;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);
  border: 1px solid rgba(255,255,255,0.18);

  &:hover {
    z-index: 20;
    box-shadow: 0 6px 24px rgba(0,0,0,0.18);
    border: 1.5px solid rgba(255,255,255,0.28);
  }
`;

const TeamName = styled.h4`
  font-size: 11px;
  font-weight: bold;
  color: #333;
  margin-top: 3px;
  margin-bottom: 3px;
`;

const TeamRole = styled.p`
  font-size: 12px;
  color: #555;
  font-style: italic;
  margin-bottom: 1px;
`;

const SubImageModal = styled.div`
  position: fixed;
  top: 40%;
  left: 40%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background: #e7f2ec;
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.2s ease-in-out;
`;

const ModalContent = styled.div`
  display: flex;
  gap: 10px;
  &:hover {
    cursor: default;
  }
`;

const SubImageItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px; 
`;

const SubImage = styled.img`
   width: 150px;
  height: 150px;
  border-radius: 8px;
  border: 1px solid #ccc;
  object-fit: cover;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
`;

const SubText = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: #333;
  margin-top: 5px;
`;

const SubRole = styled.div`
  font-size: 11px;
  color: #666;
  font-style: italic;
`;



export default Collaborations;
